import React, { useEffect } from "react";
import { Link } from "gatsby";
import { IconLogout, IconQrcode, IconSettings, IconUser } from '@tabler/icons-react';
import { ActionIcon, rem, Group, Button, Menu, Text, Avatar, Divider } from '@mantine/core';
import { useAuth0 } from "@auth0/auth0-react";

export function Profile() {
    const { user, loginWithPopup, logout, getAccessTokenSilently, isAuthenticated } = useAuth0();
    const [permissions, setPermissions] = React.useState<string[]>([]);

    useEffect(() => {
        const fetchPermissions = async () => {
            if (isAuthenticated) {
                const token = await getAccessTokenSilently();
                // Giải má token (JWT) và kiểm tra permissions
                const decodedToken = JSON.parse(atob(token.split('.')[1]));
                const permissions = decodedToken.permissions || [];
                setPermissions(permissions);
            }
        };

        fetchPermissions();
    }, [isAuthenticated, getAccessTokenSilently]);

    if (!user) return <Group>
        <Button variant="light" size="compact-sm" onClick={() => loginWithPopup()}>Sign in</Button>
    </Group>

    const hasReadSerialsPermission = permissions.includes('read:serials');

    return <Group>
        <Menu width={200} position="bottom-end" withArrow>
            <Menu.Target>
                <Group align="center">
                    <Text visibleFrom="md" my={'auto'}>{user.email}</Text>
                    <Avatar size={'sm'} radius="xl" src={user.picture} />
                </Group>
            </Menu.Target>
            <Menu.Dropdown>
                <Menu.Label>Profile</Menu.Label>
                {hasReadSerialsPermission && <Menu.Item leftSection={<IconQrcode size={14} />} component={Link} to={'/manage/serials'}>Manage Warranty</Menu.Item>}

                <Menu.Item leftSection={<IconLogout size={14} />} onClick={() => logout()}>Logout</Menu.Item>
            </Menu.Dropdown>
        </Menu>
    </Group>
}